import {
    TOGGLE_DEVICE_ERROR,
    TOGGLE_DEVICE_START,
    TOGGLE_DEVICE_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.devices.toggle, action = {type: ''}) => {
    switch (action.type) {
        case TOGGLE_DEVICE_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case TOGGLE_DEVICE_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case TOGGLE_DEVICE_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer/toggleDeviceReducer.js